/**
 * Thin wrapper for the native fetch() function.
 */

const combine = (domain, url) => {
  let _domain = domain.slice() // Make copies
  let _url = url.slice()

  if (!_domain.endsWith("/")) {
    _domain = `${_domain}/`
  }

  if (_url.startsWith("/")) {
    _url = _url.substring(1)
  }

  return `${_domain}${_url}`
}

/**
 * Returns a promise
 */
const get = ({headers, domain, subsessionToken}, url = "") => {
  return fetch(combine(domain, url), {headers: Object.assign(headers, subsessionToken && {"x-subsession-token": subsessionToken})})
}

const _post = ({domain, headers, subsessionToken, antiForgeryToken}, method = "POST", url = "", data, {headers: optionalHeaders} = {}) => {
  if (!subsessionToken) console.warn("_post missing subsession")
  return fetch(combine(domain, url), {
    method: method,
    headers: Object.assign(
      {},
      headers,
      optionalHeaders,
      subsessionToken && {"x-subsession-token": subsessionToken},
      antiForgeryToken && {
        "X-CSRF-Token": antiForgeryToken // Keep the token out of the default headers, not needed for GET
      }
    ),
    body: JSON.stringify(data)
  })
}

export default (opts) => {
  // Opts are internally defined—they do not represent the
  // config package to send to fetch() directly

  const _opts = Object.assign(
    {
      // Establish defaults
      domain: "",
      handleResponse: (resp) => new Promise((resolve) => resolve(resp))
    },
    opts
  )

  const {handleResponse} = _opts

  // API defined here
  return {
    get: (url) => get(_opts, url).then(handleResponse),
    post: (url, data, optional) => _post(_opts, undefined, url, data, optional).then(handleResponse),
    put: (url, data, optional) => _post(_opts, "PUT", url, data, optional).then(handleResponse),
    patch: (url, data, optional) => _post(_opts, "PATCH", url, data, optional).then(handleResponse),
    delete: (url, data, optional) => _post(_opts, "DELETE", url, data, optional).then(handleResponse)
  }
}

// Deprecated functions 👇

export const tokenRequest = (request, token) => {
  if (typeof token == "string") console.warn("tokenRequest", token)
  if (typeof token == "string") request = request.set("X-CSRF-Token", token)
  if (token && typeof token == "object") {
    const {csrf, subsession} = token
    if (csrf) request = request.set("X-CSRF-Token", csrf)
    if (!subsession) console.warn("fetchSession missing subsession")
    if (subsession) request = request.set("x-subsession-token", subsession)
  }
  return request
}

export const withSecurityKey = (request, securityKey) => {
  return request.set("X-Security-Key", securityKey)
}
